export default {
  methods: {
    updateComponentConfigGroup({swatchId, componentName, swatchObj, componentGroup, color = null}) {
      return new Promise((resolve, reject) => {
        if(Number(swatchId) === 4 && this.$store.state.recipe.recipe_v2.components[componentName].subgroup === 'library') {
          this.$recipe.removeToolkitOptions(componentName);
          const recipeMapEntry = {
            group: 'solids',
            subgroup: 'solids',
            material_type: swatchObj.material_type
          }
          this.$recipe.updateComponents(componentName, swatchId, componentGroup, recipeMapEntry, color);
          return resolve();
        }

        if (!swatchObj?.component_config_groups) {
          this.$recipe.updateComponents(componentName, swatchId, componentGroup, null, color);
          return resolve();
        }
        this.$store.dispatch("componentConfigGroup/GET_COMPONENT_GROUPING_BY_SWATCH", { swatchId , componentName })
          .then(group => {
            if (group && Object.keys(group).length > 0) {
              this.updateRecipeGroup({group});
            } else {
              this.$recipe.updateComponents(componentName, swatchId, componentGroup, null, color);
            }
            resolve();
          }).catch(reject);
      });
    },
    updateRecipeGroup({group}) {
      const recipeGroup = Object.keys(group);
      recipeGroup.forEach(componentName => {this.$recipe.update(componentName, group[componentName])})
    }
  },
};
